const translations = {
  en: {
    home: "Home",
    shop: "Shop",
    blog: "Blog",
    about: "About",
    contact: "Contact",
    login: "Login",
    search: "Search",
    placeholder: "what do you need",
    getService: "Get Service For 24/7",
    allCategory: "All Category",
    latestProduct: "Latest Product",
    topRatedProduct: "Top Rated Product",
    discountProduct: "Discount Product",
    hagereShop: "Hagere Shop",
    availability: "Availability",
    shareOn: "Share on",
    inStock: "In Stock",
    outOfStock: "Out of Stock",
    addToCart: "Add To Cart",
    addToWishlist: "Add to Wishlist",
    buyNow: "Buy Now",
    chatSeller: "Chat Seller",
    reviews: "Reviews",
    description: "Description",
    relatedProducts: "Related Products",
    featuredProducts: "Feature Products",
    selectCategory: "Select category",
    siteName: "Hagere online shopping",
    products: "Products",
    filterProduct: "Filter Product",
    price: "Price",
    rating: "Rating",
    sortBy: "Sort By",
    lowToHigh: "Low to High Price",
    highToLow: "High to Low Price",
    fromLabel: "From",
    // dashboard
    dashboard: "Dashboard",
    myOrders: "My Orders",
    wishlist: "Wishlist",
    chat: "Chat",
    changePassword: "Change Password",
    logout: "Logout",
    // chat
    messageTitle: "Messages",
    selectSeller: "Select seller",
    inputMessagePlaceholder: "Type a message...",
    sentMessage: "{name} sent you a message",
    changePasswordTitle: "Change Password",
    oldPasswordLabel: "Old Password",
    newPasswordLabel: "New Password",
    update: "Update",
    updating: "Updating...",
    cartTitle: "Card",
    orderSummary: "Order Summary",
    itemsAndShippingIncluded: "{items} items and shipping fee included",
    totalAmount: "Total Amount",
    payNow: "Pay Now",
    payWithChapa: "Pay with Chapa",
    processing: "Processing...",
    completeYourPayment: "Complete Your Payment",
    chapaRedirectMessage:
      "You will be redirected to Chapa's secure payment page",
    paymentInitializationFailed:
      "Payment initialization failed. Please try again.",
    paymentError: "Payment error. Please try again.",
    ordersLabel: "Orders",
    pendingOrders: "Pending Orders",
    cancelledOrders: "Cancelled Orders",
    recentOrders: "Recent Orders",
    orderId: "Order Id",
    paymentStatus: "Payment status",
    orderStatus: "Order status",
    action: "Action",
    view: "View",
    paymentPaid: "Paid",
    paymentUnpaid: "Unpaid",
    paymentPending: "Pending",
    paymentFailedLabel: "Failed",
    delivered: "Delivered",
    paymentMethodsTitle: "Payment Methods",
    itemLabel: "Item",
    deliveryFee: "Delivery Fee",
    totalLabel: "Total",
    proceedToCheckout: "Proceed to checkout",
    shopNow: "Shop Now",
    delete: "Delete",
    priceLabel: "Price",
    currency: "Birr",
    myOrders: "My Orders",
    productReviews: "Product Reviews",
    updateReview: "Update Review",
    submit: "Submit",
    login: "Login",
    orderStatusPlaceholder: "--order status---",
    statusPlaced: "Placed",
    statusPending: "Pending",
    statusCancelled: "Cancelled",
    statusWarehouse: "Warehouse",
    includeShipping: "include shipping fee",
    deliverTo: "Deliver to",
    homeLabel: "Home",
    products: "Products",
    brandLabel: "Brand",
    quantityLabel: "Quantity",
    orderedBy: "Ordered by",
    normalPrice: "Normal price",
    discountLabel: "Discount",
    outOfStockToast: "This product is out of stock",
    placeOrder: "Place Order",
    cancel: "Cancel",
    itemsTotal: "Items Total",
    savedAddresses: "Saved Addresses",
    useLabel: "Use",
    deleteLabel: "Delete",
    deleteAddressTitle: "Delete Address",
    deleteAddressConfirm:
      "Are you sure you want to delete this saved address? This action cannot be undone.",
    shippingInformation: "Shipping Information",
    name: "Name",
    addressLabel: "Address",
    phoneLabel: "Phone",
    postLabel: "Post",
    regionLabel: "Region",
    cityLabel: "City",
    zoneLabel: "Zone",
    save: "Save",
    deliverTo: "Deliver to",
    change: "change",
    emailTo: "Email to",
    // auth / login
    emailLabel: "Email",
    emailPlaceholder: "your@email.com",
    passwordLabel: "Password",
    passwordPlaceholder: "••••••••",
    forgotPassword: "Forgot password?",
    sendResetLink: "Send Reset Link",
    pleaseEnterEmail: "Please enter your email",
    resetLinkSent: "Password reset link sent to your email",
    loggingIn: "Logging in...",
    dontHaveAccount: "Don't have an account?",
    register: "Register",
    // register / verification
    processing: "Processing...",
    alreadyHaveAccount: "Already have an account?",
    verifyEmailTitle: "Verify Your Email",
    verificationSentTo: "We've sent a code to",
    verifying: "Verifying...",
    verifyEmail: "Verify Email",
    resend: "Resend",
    enterVerificationCode: "Please enter a 6-digit verification code",
    didntReceiveCode: "Didn't receive the code?",
    // reset password
    resetPasswordTitle: "Reset Password",
    newPasswordLabel: "New Password",
    confirmPasswordLabel: "Confirm Password",
    passwordsNotMatch: "Passwords do not match",
    resetPasswordButton: "Reset Password",
    resetPasswordSuccess: "Password reset successful.",
    // confirm order
    backToDashboard: "Back to Dashboard",
    paymentFailed: "Payment Failed",
    paymentSucceeded: "Payment Succeeded",
    // footer
    addressLabelFull: "Address",
    emailLabel: "Email",
    usefulLinks: "Useful links",
    aboutShop: "About our Shop",
    deliveryInfo: "Delivery Information",
    privacy: "Privacy Policy",
    joinUs: "Join us",
    newsletterText:
      "Get Email updates about our latest and shop specials offers",
    newsletterPlaceholder: "Enter your mail",
    subscribe: "Subscribe",
    allRights: "All rights reserved",
    siteName: "Hagere Online Shopping",
  },
  am: {
    home: "ዋና",
    shop: "ግብይት",
    blog: "ብሎግ",
    about: "ስለ እኛ",
    contact: "አግኙን",
    login: "ግባ",
    search: "ፈልግ",
    placeholder: "ምን እንፈልጋለን",
    getService: "24/7 አገልግሎት",
    allCategory: "ሁሉም ምድቦች",
    latestProduct: "የአዲሱ ምርቶች",
    topRatedProduct: "ከፍ ያለ ደረጃ ምርቶች",
    discountProduct: "ቅናሽ ያላቸው ምርቶች",
    hagereShop: "የሀገሬ መደር ሱቅ",
    availability: "አለ",
    shareOn: "እንዲካፈሉ",
    inStock: "በእቃ ላይ አለ",
    outOfStock: "ከእቃ ውስጥ የወገደ",
    addToCart: "ለግዢ ያክሉ",
    addToWishlist: "ወደ ፍለጋ ይጨምሩ",
    buyNow: "አሁን ግዙ",
    chatSeller: "ከደንበኛ ጋር ይጫወቱ",
    reviews: "እይታዎች",
    description: "መግለጫ",
    relatedProducts: "ተዛማጅ ምርቶች",
    featuredProducts: "ተፈጥሯዊ ምርቶች",
    selectCategory: "ምድብ ይምረጡ",
    siteName: "ሀገሬ መደብር ገበያ",
    products: "ምርቶች",
    filterProduct: "የምርት ማጣጣሪያ",
    price: "ዋጋ",
    rating: "ደረጃ",
    sortBy: "ይቅደም",
    lowToHigh: "ከዝቅተኛ ወደ ከፍ ዋጋ",
    highToLow: "ከከፍ ወደ ዝቅ ዋጋ",
    fromLabel: "ከ",
    // dashboard
    dashboard: "ዳሽቦርድ",
    myOrders: "የኔ ትእዛዞች",
    wishlist: "ፍለጋ",
    chat: "ውይይት",
    changePassword: "የይለፍ ቃል ቀይር",
    logout: "ውጣ",
    // chat
    messageTitle: "መልዕክቶች",
    selectSeller: "ሻጭ ይምረጡ",
    inputMessagePlaceholder: "መልዕክት ያስገቡ...",
    sentMessage: "{name} መልዕክት ላከዎታል",
    changePasswordTitle: "የይለፍ ቃል ቀይር",
    oldPasswordLabel: "የድሮ የይለፍ ቃል",
    newPasswordLabel: "አዲስ የይለፍ ቃል",
    update: "አዘምን",
    updating: "በማዘምን ላይ...",
    cartTitle: "የጋርድ",
    orderSummary: "የትእዛዝ ማጠቃለያ",
    itemsAndShippingIncluded: "{items} እቃዎች እና የመላኪያ ክፍያ ይሰቀላሉ",
    totalAmount: "ጠቅላላ መጠን",
    payNow: "አሁን ክፈል",
    payWithChapa: "ከChapa ጋር ክፈል",
    processing: "በሂደት ላይ...",
    completeYourPayment: "ይህን ይክፈሉ",
    chapaRedirectMessage: "ወደ Chapa የደህንነት ክፍያ ገጽ ይመለሳሉ",
    paymentInitializationFailed: "የክፍያ መነሳት አልተሳካም። እባክዎ ደግመው ይሞክሩ።",
    paymentError: "የክፍያ ስህተት። እባክዎ ደግመው ይሞክሩ።",
    paymentMethodsTitle: "የክፍያ ዘዴዎች",
    itemLabel: "እቃ",
    deliveryFee: "የእቃ ክፍያ",
    totalLabel: "አጠቃላይ",
    proceedToCheckout: "ወደ ክፍያ ይቀጥሉ",
    shopNow: "አሁን ገበያ ይጎብኙ",
    delete: "ሰርዝ",
    priceLabel: "ዋጋ",
    currency: "ብር",
    myOrders: "የኔ ትእዛዞች",
    productReviews: "የምርት እይታዎች",
    updateReview: "እይታ አዘምን",
    submit: "አስገባ",
    login: "ግባ",
    orderStatusPlaceholder: "--የትእዛዝ ሁኔታ---",
    statusPlaced: "ተደርጓል",
    statusPending: "በሂደት ላይ",
    statusCancelled: "ተሰርዟል",
    statusWarehouse: "በመደብር ውስጥ",
    includeShipping: "የመላኪያ ክፍያ ጨምሮ",
    deliverTo: "ወደ",
    homeLabel: "ቤት",
    products: "ምርቶች",
    brandLabel: "ምርት ምርት",
    quantityLabel: "ብዛት",
    orderedBy: "በማን ተቀይሯል",
    normalPrice: "የመደበኛ ዋጋ",
    discountLabel: "ቅናሽ",
    ordersLabel: "ትእዛዞች",
    pendingOrders: "የሚጠበቁ ትእዛዞች",
    cancelledOrders: "ተሰርዟል የሆኑ ትእዛዞች",
    recentOrders: "የቅርብ ዘመን ትእዛዞች",
    orderId: "የትእዛዝ መለያ",
    paymentStatus: "የክፍያ ሁኔታ",
    orderStatus: "የትእዛዝ ሁኔታ",
    action: "እርምጃ",
    view: "ይመልከቱ",
    paymentPaid: "ተከፈለ",
    paymentUnpaid: "አልተከፈለም",
    paymentPending: "በሂደት ላይ",
    paymentFailedLabel: "አልሰራም",
    delivered: "ተልኳል",
    outOfStockToast: "ይህ ምርት ከእቃ ውስጥ የወገደ ነው",
    placeOrder: "እየተያዙ ትእዛዝ",
    cancel: "ሰርዝ",
    itemsTotal: "የእቃው ጠቅላላ",
    savedAddresses: "የተቀዳዳ አድራሻዎች",
    useLabel: "አገልግሎት",
    deleteLabel: "ሰርዝ",
    deleteAddressTitle: "አድራሻ ሰርዝ",
    deleteAddressConfirm:
      "ይህን የተቀዳዳ አድራሻ ማስወገድ እርግጠኛ ነህ? ይህ ተግባር ከእንገደም በኋላ አይታወስም።",
    shippingInformation: "የእቃ መላኪያ መረጃ",
    name: "ስም",
    addressLabel: "አድራሻ",
    phoneLabel: "ስልክ",
    postLabel: "ፖስታ",
    regionLabel: "ክልል",
    cityLabel: "ከተማ",
    zoneLabel: "ዞን",
    save: "አስቀምጥ",
    deliverTo: "ወደ ይህ ይደርሳል",
    change: "ቀይር",
    emailTo: "ኢሜል",
    // auth / login
    emailLabel: "ኢሜል",
    emailPlaceholder: "your@email.com",
    passwordLabel: "የይለፍ ቃል",
    passwordPlaceholder: "••••••••",
    forgotPassword: "የሚያስታወስ ይረዳኝ?",
    sendResetLink: "የተዘዋዋሪ አገናኝ ላክ",
    pleaseEnterEmail: "እባክዎ ኢሜልዎን ያስገቡ",
    resetLinkSent: "የይለፍ ቃል ማስተካከያ አገናኝ ወደ ኢሜልዎ ተልኗል",
    loggingIn: "እየግባን ነው...",
    dontHaveAccount: "አካውንት የለዎትም?",
    register: "ይመዝገቡ",
    // register / verification
    processing: "በሂደት ላይ...",
    alreadyHaveAccount: "የአካውንት ባለዎት ነዎት?",
    verifyEmailTitle: "ኢሜልዎን ያረጋግጡ",
    verificationSentTo: "ኮድ ወደ ዚህ ተልኳል",
    verifying: "እየተረጋገጠ...",
    verifyEmail: "ኢሜል ያረጋግጡ",
    resend: "እንደገና ላክ",
    enterVerificationCode: "እባክዎ 6-ዲጂት የሆነ የማረጋገጫ ኮድ ያስገቡ",
    didntReceiveCode: "ኮድ ካልደረሰዎት?",
    // reset password
    resetPasswordTitle: "የይለፍ ቃል ዳግም ቀይር",
    newPasswordLabel: "አዲስ የይለፍ ቃል",
    confirmPasswordLabel: "የይለፍ ቃልን ያረጋግጡ",
    passwordsNotMatch: "የይለፍ ቃላት አይዛመዱም",
    resetPasswordButton: "የይለፍ ቃል ዳግም ቀይር",
    resetPasswordSuccess: "የይለፍ ቃል በተሳካ ሁኔታ ተቀይሯል",
    // confirm order
    backToDashboard: "ወደ ዳሽቦርድ ተመለስ",
    paymentFailed: "ክፍያ አልተሳካም",
    paymentSucceeded: "ክፍያ ተሳካ",
    // footer
    addressLabelFull: "አድራሻ",
    emailLabel: "ኢሜል",
    usefulLinks: "ጠቃሚ አገናኝ",
    aboutShop: "ስለ መደር ሱቅ",
    deliveryInfo: "የእቃ መላኪያ መረጃ",
    privacy: "የግል ደህንነት ፖሊሲ",
    joinUs: "ተቀላቀሉ",
    newsletterText: "የኢሜል ዝግጅት ስለ ዝርዝር እና ልዩ ቅናሾች ያግኙ",
    newsletterPlaceholder: "ኢሜልዎን ያስገቡ",
    subscribe: "ይመዝገቡ",
    allRights: "ሁሉም መብቶች የተጠበቁ",
    siteName: "ሀገሬ መደብር ገበያ",
  },
};

export default translations;
